module.exports = __webpack_public_path__ + "img/expiring-logo.fa6c49ab.png";